<template>
    <div>
        <b-row>
            <b-col></b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                <b-form-group   horizontal label="Mostrar">
                <b-input-group>
                    <b-form-select v-model="limite" slot="append" @input="listProformas" >
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </b-form-select>
                </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="1">
                <b-button variant="secondary" @click="listProformas"><i class="fa fa-sync-alt"></i> </b-button>
            </b-col>
        </b-row><br>
        <div class="row">
            <div class="col-md-4">
                <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
            </div>
            <div class="col-md-6">
                <div class="float-right">
                <b-pagination
                    size="sm"
                    :total-rows="total"
                    v-model="currentPage"
                    @input="listProformas"
                    :per-page="limite"
                ></b-pagination>
                </div>
            </div>
        </div>
        <b-row>
            <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                <b-table 
                    responsive
                    small
                    striped
                    outlined
                    :items="proformas"
                    :fields="proformas_fields"
                    :current-page="pactual"
                    :per-page="limite"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :busy="isBusy"
                    @filtered="onFiltered"
                    >
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template slot="emision" slot-scope="row">
                        <div v-if="row.item.proforma.fechaEmision !=null">
                            {{ row.item.proforma.fechaEmision | moment('D/M/Y hh:mm:ss A') }}
                        </div>
                        <div v-else>
                            {{ row.item.created_at | moment('D/M/Y hh:mm:ss A') }}
                        </div>
                    </template>
                    <template slot="receptor" slot-scope="row">
                        <template v-if="row.item.proforma.receptor">
                            {{row.item.proforma.receptor.nro}} - {{row.item.proforma.receptor.razonSocial}}
                        </template>
                    </template>
                    <template slot="montoTotal" slot-scope="row">
                        <template v-if="row.item.proforma.moneda && row.item.proforma && row.item.proforma.totales">
                            {{row.item.proforma.moneda.simbolo}} {{parseFloat(row.item.proforma.totales.importeTotal).toFixed(2)}}
                        </template>
                    </template>
                    <template slot="acciones" slot-scope="row">
                        <b-button-group>
                            <button size="sm" @click="row.toggleDetails" type="button" class="btn" title="Mas opciones">
                                <template v-if="!row.detailsShowing">
                                    <i class="fa fa-plus"></i>
                                </template>
                                <template v-else>
                                    <i class="fa fa-minus"></i>
                                </template>
                            </button>
                            <b-button size="sm" v-b-tooltip.hover variant="primary" @click="returnProforma(row.index, row.item)"><i class="fa fa-pencil-alt" title="Editar Proforma"></i></b-button>
                            <b-button size="sm" v-b-tooltip.hover variant="secondary" @click="sendPdf(row)"><i class="fa fa-tv" title="Ver Proforma"></i></b-button>
                            <b-button size="sm" v-b-tooltip.hover variant="secondary" @click="downloadPdf(row.item)"><i class="fa fa-download" aria-hidden="true"></i></b-button>
                            <b-button size="sm" v-b-tooltip.hover v-b-modal.sendproformaemail1 variant="secondary" @click="dataSendMail(row.item)"><i class="fa fa-envelope" title="Enviar por Correo (Proximanente)"></i></b-button>
                            <b-button size="sm" v-b-tooltip.hover variant="dark" @click="sendDataProforma(row.item, 1)"><b title="Convertir a Factura">F</b></b-button>
                            <b-button v-b-modal.messageConvert size="sm" v-b-tooltip.hover variant="dark" @click="sendDataProforma(row.item, 2)"><b title="Convertir a Boleta ">B</b></b-button>
                            <b-button v-b-modal.messageConvert size="sm" v-b-tooltip.hover variant="dark" @click="sendDataProforma(row.item, 3)"><b title="Convertir a Guia ">G</b></b-button>
                            <b-button v-b-modal.messageConvert size="sm" v-b-tooltip.hover variant="success" @click="sendDataProforma(row.item, 4)" title="convertir a Proforma"><i class="fa fa-1x fa-copy"></i></b-button>
                            <b-button size="sm" v-b-modal.sendfacturaemail1 v-b-tooltip.hover variant="danger" @click="predeleteProforma(row.item)"><i class="fa fa-trash" title="Eliminar Proforma"></i></b-button>
                        </b-button-group>  
                    </template>
                    <template v-slot:row-details="row">
                        <b-card >
                            <b-table
                            head-variant="light"
                            :outlined="outlined"
                            striped
                            hover
                            :items="row.item.proforma.items"
                            :fields="listaitems_fields"
                            :busy="row.item.loading"
                            >
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Cargando...</strong>
                            </div>
                            <template slot="index" slot-scope="row">{{ row.index+1 }}</template>
                            <template slot="cantidad" slot-scope="row">
                                <div>
                                    <template v-if="row.item.cantidad">
                                        {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                                    </template>
                                </div>
                            </template>
                            <template slot="precioVentaUnitario" slot-scope="row">
                                <div>
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template
                                    v-if="row.item.precioVentaUnitario"
                                >{{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}</template>
                                </div>
                            </template>
                            <template slot="descuento" slot-scope="row">
                                <div>
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                    <template v-if="row.item.descuento">
                                        {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                                    </template>
                                </div>
                            </template>
                            <template slot="valorVenta" slot-scope="row">
                                <div>
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template v-if="row.item.valorVenta">
                                    {{ Number.parseFloat(row.item.valorVenta*(row.item.porcentajeImpuesto == '18.00000' ? 1.18 : 1.105)).toFixed(2) }}
                                     <div style="float:right;color:red">
                                        {{row.item.porcentajeImpuesto == '18.00000' ? '18%' : '10.5%'}}
                                    </div>
                                </template>
                                </div>
                            </template>
                            </b-table>
                            <label v-if="row.item.proforma.observaciones != null" style="color:red">observaciones: </label> {{row.item.proforma.observaciones}} 
                            <label v-if="row.item.proforma.atencion != null" style="color:red">Atencion: </label> {{row.item.proforma.atencion}} 
                            <label v-if="row.item.proforma.plazoentrega != null" style="color:red">Plazo Entrega: </label> {{row.item.proforma.plazoentrega}} 
                            <label v-if="row.item.proforma.formapago != null" style="color:red">Forma de Pago: </label> {{row.item.proforma.formapago}} 
                            <label v-if="row.item.proforma.garantia != null" style="color:red">Garantia: </label> {{row.item.proforma.garantia}} 
                            <label v-if="row.item.proforma.telefono != null" style="color:red">Telefono: </label> {{row.item.proforma.telefono}} 
                        </b-card>
                    </template>
                </b-table>
                <b-row>
                    <b-col cols="12"	sm="4"	md="6"	lg="8"	xl="8">
                        <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                    </b-col>
                    <b-col cols="12"	sm="8"	md="6"	lg="4"	xl="4">
                        <b-pagination size="sm" :total-rows="total" v-model="currentPage" :per-page="limite" @input="listProformas"></b-pagination>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-modal id="pdfproforma" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="pdfproforma">
            <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
            <template v-else>
            <template v-if="pdfobject !==''">
                <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
            </template>
            </template>
        </b-modal>
    <b-modal id="sendproformaemail1" title="Enviar por Correo" v-model="previacorreo">
        <div role="group">
        <label for="inputLive">Correos:</label>
        <b-form-input v-model="recipients" type="email" @keyup.enter="sendMail()"></b-form-input>
        <p class="input-requerido">Ingresa un correo ó varios separados por comas (,)</p>
        </div>
            <div slot="modal-footer" class="w-100">
            <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="sendMail()">
            Enviar
            </b-btn>
            <b-btn v-else size="sm" class="float-right" variant="secondary">
            <i class="fa fa-spin fa-spinner"></i> Enviando...
            </b-btn>
        </div>
    </b-modal>
    <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import download from "downloadjs";
import axios from 'axios'
import ModalPreview from '@/components/factura/complementos/ModalPreview'
    export default {
       name: 'ProformaConsulta',
       components: {
           ModalPreview
       },
       data: () => {
           return {
                previacorreo: false,
                sendcorreo: false,
                recipients: '',
                bodycomment: 'Esta a punto de convertir esta proforma en Factura',
                noticeConvert: false,
                total: 0.00,
                desde: 0.00,
                hasta: 0.00,
                totalRows: 0,
                cargandopdf2: false,
                pdfobject: null,
                pdfproforma: false,
                cargando: false,
                small: true,
                striped: true,
                outlined: true,
                pactual: 1,
                limite: 10,
                sortBy: null,
                sortDesc: false,
                sortDirection: 'desc',
                proforma: {},
                proformas: [],
                proformas_fields: [
                    {key: 'serie', label: 'Serie', sorteable: true},
                    {key: 'numero', label: 'Numero', sorteable: true},
                    {key: 'emision', label: 'Emisión', sorteable: true},
                    {key: 'receptor', label: 'Receptor', sorteable: true},
                    {key: 'montoTotal', label: 'Monto Total', sorteable: true},
                    {key: 'acciones', label: 'Acciones'}
                ],
                listaitems_fields: [
                    { key: "index" },
                    { key: "codigoProducto", label: "Codigo", sorteable: true },
                    { key: "unidadMedidaCantidad", label: "Unidad", sorteable: true },
                    { key: "descripcion", label: "Descripción", sorteable: true },
                    { key: "observacion", label: "Observación", sorteable: true },
                    { key: "cantidad", label: "Cantidad", sorteable: true },
                    { key: "precioVentaUnitario", label: "Precio Unit", sorteable: true },
                    { key: "descuento", label: "Descuento", sorteable: true },
                    { key: "valorVenta", label: "Precio Total", sorteable: true }
                ],
                isBusy: false,
                bufferData: {},
                tipoDocConvert: 1,
                currentPage: 1,
                cargandopdf: false
           }
       },
       created() {
            this.listProformas()
       },
       mounted() {
           this.initReturn()
       },
       methods: {
           onFiltered (filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
           },
           dataSendMail: function (data) {
               this.proforma = data
           },
           sendMail: function () {
               this.previacorreo = true,
                this.sendcorreo = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'proformas/pdf/mail', {
                    token: this.$store.getters.userToken,
                    id: this.proforma.idProforma,
                    mail: this.recipients
                })
                .then(response => (
                    this.sendcorreo = false,
                    this.previacorreo = false,
                    this.$snotify.success(response.data.msg, 'Exito')
                ))
                .catch(error => (
                    this.previacorreo = false,
                    this.$snotify.error(error.response.data.response, 'Error')
                ))
           },
           sendDataProforma: function (data, tipo) {
                this.bufferData = data
                // Convertir a factura
                if(tipo === 1){       
                    this.tipoDocConvert = 1,
                    // this.bodycomment = 'Esta a punto de convertir esta proforma en Factura'
                    this.convertInvoice()
                // Convertir a boleta
                }else if(tipo === 2){            
                    this.tipoDocConvert = 2,
                    // this.bodycomment = 'Esta a punto de convertir esta proforma en Boleta'
                    this.convertInvoice()
                // Convertir a guia de remision
                }else if(tipo === 3){       
                    this.tipoDocConvert = 3,    
                    // this.bodycomment = 'Esta a punto de convertir esta proforma en Guia de Remision'
                    this.convertInvoice()
                // Convertir a proforma 
                }  else if(tipo === 4){       
                    this.tipoDocConvert = 4,    
                    // this.bodycomment = 'Esta a punto de convertir una nueva PROFORMA con los items de la proforma seleccionada.'
                    this.convertInvoice()
                }    
           },
           convertInvoice: function () {
              switch(this.tipoDocConvert){
                    case 1:
                        this.$store.commit('setproforma', this.bufferData),
                        this.$router.push('/emision/factura').catch(err => {})
                        break;
                    case 2: 
                        this.$store.commit('setproforma', this.bufferData),
                        this.$router.push('/emision/boleta').catch(err => {})
                        break;
                    case 3: 
                        this.$store.commit('setproforma', this.bufferData),
                        this.$router.push('/emision/guia').catch(err => {})  
                        break;
                    case 4: 
                        this.proformaRapida(this.bufferData)
                        this.changeTab(0)
                        break;
              }
           },
           listProformas: function () {
                this.isBusy = true
                axios
                .post(process.env.VUE_APP_API_URL + 'proformas/listar', {
                    token: this.$store.getters.userToken,
                    page: this.currentPage,
                    limit: this.limite,
                    order: this.orden
                })
                .then(response => (
                    this.isBusy = false,
                    this.proformas = response.data.data,
                    this.total = response.data.total,
                    this.desde = response.data.from,
                    this.hasta = response.data.to
                ))
                .catch(error => {
                    this.$snotify.error(error.response.data.msg,'Error'),
                    this.isBusy = false
                })
            },
            returnProforma: function (index, item) {
                this.changeTab(0),
                this.editProforma(item)
            },
            initReturn: function () {
                let proformaBlank = {}
                this.editProforma(proformaBlank)
                this.proformaRapida(proformaBlank)
            },
            predeleteProforma: function (value) {
                this.$swal({
                title: 'Eliminar Proforma',
                text: 'Seguro de eliminar la proforma '+ value.serie +' - '+ value.numero,
                icon: 'error',
                buttons: true,
                dangerMode: true
                }).then((willDelete) => {
                    if(willDelete){
                        this.deleteProforma(value.idProforma)        
                    }
                })
            },
            deleteProforma: function (value) {
                this.isBusy = true
                axios
                .post(process.env.VUE_APP_API_URL + 'proformas/eliminar', {
                    token: this.$store.getters.userToken,
                    id: value
                })
                .then(response => (
                    this.listProformas(),
                    this.$snotify.success(response.data.msg,'Exito')
                ))
                .catch(error => {
                    this.$snotify.error(error.response.data.msg,'Error')
                })
            },
            editProforma: function (value){
                this.$emit("proforma", value);
            },
            proformaRapida: function (value){
                this.$emit("proformaRapida", value);
            },
            changeTab: function (value){
                this.$emit("tabindex", value);
            },
            sendPdf: function (row) {
                this.pdfproforma = true,
                this.pdfobject = '',
                this.cargandopdf2 = true
                axios
                .post(process.env.VUE_APP_API_URL + 'proformas/pdf', {
                    token: this.$store.getters.userToken,
                    id: row.item.idProforma
                })
                .then(response => (
                    this.pdfobject = response.data.pdf,
                    this.cargandopdf2 = false
                ))
                .catch(error => {
                    this.cargandopdf2 = false,
                    this.pdfproforma = false,
                    this.$snotify.error(error.response.data.msg,'Error')
                })
            },
            downloadPdf: function(data) {
            let tag = document.createElement("i");
            tag.classList.add("fa", "fa-spin", "fa-spinner");
            let name = data.serie + "-" + data.numero + ".pdf";
            let file = "data:application/pdf;base64," + data.pdf;
            this.cargandopdf = true;
            this.$swal({
                title: "Procesando Descarga",
                content: tag,
                icon: "info",
                buttons: false,
                dangerMode: false
            });
            axios
                .post(process.env.VUE_APP_API_URL + "proformas/pdf", {
                token: this.$store.getters.userToken,
                id: data.idProforma
                })
                .then(response =>{
                    const base64 = response.data.pdf;
                    const byteCharacters = atob(base64);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: "application/pdf" });
                    const url = URL.createObjectURL(blob);
                    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                    if (isIOS) {
                    window.location.href = url;
                    } else {
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = name;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    }
                    setTimeout(() => URL.revokeObjectURL(url), 5000);
                    this.cargandopdf = false;
                    this.$swal.close(); 
                })
                .catch(error => {
                this.$swal.close(),
                this.$snotify.error(error.response.data.msg, 'Error')
                })
            },
       }
    }
</script>

<style>
    .notice{
        font-size: 2em;
        color: #006666;
    }
    .tamanioletra {
        font-size: 13px;
        font-family: "Roboto Mono";
        margin-left: 3%;
        padding: 0px;
    }
</style>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto+Mono&display=swap");
</style>



